import './App.css';
import { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { getUser } from '../utilities/services/users';
import Home from '../pages/Home/Home';
import Login from '../pages/Login/Login';
import UserProfile from '../pages/UserProfile/UserProfile';
import { getUserData } from '../utilities/api/users';


export default function App() {
  const [user, setUser] = useState(getUser());
  const [isMobile, setIsMobile] = useState(false)

  const updateUser = (user) => {
    setUser(user)
  }

  const fetchUserData = async (user) => {
    try {
      const updatedUser = await getUserData(user._id)
      if (updatedUser) {
        setUser(updatedUser);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  }

  
  // check if device is mobile
  useEffect(() => {
    if(window.innerWidth <= 768){
      setIsMobile(true)
    }
    window.addEventListener('resize', () => {
      if(window.innerWidth <= 768){
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    })
  }, [])


  // Fetch user data on initial load
  useEffect(() => {
    if (user && user._id) {
      fetchUserData(user);
    }
    // eslint-disable-next-line
  },[(user&&user._id)&& user._id])


  // Update user data every 10 minutes
  useEffect(() => {
    // Fetch user data on initial load
    if (user && user._id) {
      fetchUserData(user);
    }
    const interval = setInterval(() => {
      if (user && user._id) {
        fetchUserData(user);
      }
    }, 300000)
    // }, 10000)
    return () => clearInterval(interval);
    // eslint-disable-next-line
  },[])

  return (
    <div className='App'>
      {user? 
      <main className='body'>
        {/* <NavBar user={user} updateUser={updateUser}/> */}
        <Routes>
          { (user.userType === 'admin' || user.userType === 'manager') &&
          <>
          <Route path='*' element={<Home 
          user={user}
          updateUser={updateUser}
          isMobile={isMobile}/>}
          />
          <Route path='/userProfile' element={<UserProfile user={user} />} />
          </>
          }
          { user.userType === 'analyst' &&
          <>
          <Route path='*' element={<Home 
          user={user}
          updateUser={updateUser}
          isMobile={isMobile}/>} 
          />
          <Route path='/userProfile' element={<UserProfile user={user} />} />
          </>
          }
          <Route path='/*' element={<Home 
          user={user}
          updateUser={updateUser}
          isMobile={isMobile}/>}
          />
        </Routes>
      </main>
      :
      <main className='login body'>
        <Routes>
          <Route path='/*' element={<Login user={user} updateUser={updateUser} />} />
        </Routes>
      </main>
      }
    </div>
  );
}
